import { IDocument } from '@/types';
import { getUrl } from '@/utils/api';

function useDocuments(filter?: string) {
  let url = `v1/documents`;
  if (filter) {
    url += `?query=${filter}`;
  }
  const query = getUrl(url);
  return {
    ...query,
    data: query.data as IDocument[],
  };
}

export default useDocuments;
